import { Injectable, TemplateRef } from '@angular/core';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';
import { SgSidenavComponent } from './sidenav.component';

@Injectable({ providedIn: 'root' })
export class SgSidenavService {
  sidenavContainer$ = new BehaviorSubject<MatSidenavContainer>(null);
  toggleLeftSidenavComponent$ = new BehaviorSubject<boolean>(null);
  sideNavComponent$ = new BehaviorSubject<TemplateRef<any>>(null);
  mediaMatcher$: BehaviorSubject<MediaQueryList> = new BehaviorSubject<MediaQueryList>(null);
  leftSidenavComponent$ = new BehaviorSubject<SgSidenavComponent>(null);

  constructor() {}

  injectComponent(component: TemplateRef<any>) {
    this.sideNavComponent$.next(component);
  }

  removeComponent() {
    this.sideNavComponent$.next(null);
  }

  toggleLeftSidenav(toggle?: boolean) {
    this.toggleLeftSidenavComponent$.next(toggle ?? null);
  }
}
